import React from 'react';
import { AtSignIcon, MailIcon } from 'lucide-react';
import { ColombiaFlag } from '../ColombiaFlag';
import { contact } from '../../data/landing';
export function Footer() {
  return <footer className="bg-brand px-5 py-14" data-id="element-119" data-mp="2f4juhykz3x1o">
      <div className="mx-auto max-w-3xl text-center" data-id="element-120" data-mp="2f3ildznipkml">
        <p className="flex items-center justify-center gap-3 text-xl font-black uppercase tracking-[0.15em] text-white" data-id="element-121" data-mp="2a607duun8f7q">
          <ColombiaFlag className="h-4 w-6" data-id="element-122" data-mp="1mfczh9kq9pl6" />
          Hábil Online™
        </p>
        <p className="mt-4 text-base text-white" data-id="element-123" data-mp="1hhbbqbccx23d">
          El sistema de curación N°1 para personas con colon irritable en Colombia.
        </p>
        <p className="mt-1 text-sm text-white/75" data-id="element-124" data-mp="1w7ilm2oatcsg">
          Porque cuidar tu digestión no debería costarte tu vida social.
        </p>
        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" data-id="element-125" data-mp="13poikkdpo9ot">
          <li data-id="element-126" data-mp="13nk6vg9km6dz">
            <a href={`mailto:${contact.email}`} className="flex items-center gap-2 text-white transition-colors duration-150 ease-out hover:text-gold" data-id="element-127" data-mp="yqla0pyivlc3">
              <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-128" data-mp="1ehamemds7212" />
              {contact.email}
            </a>
          </li>
          <li data-id="element-129" data-mp="1ihb4qi403xde">
            <a href={`https://instagram.com/${contact.instagram.replace('@', '')}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white transition-colors duration-150 ease-out hover:text-gold" data-id="element-130" data-mp="1nanqmkhapq2g">
              <AtSignIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-131" data-mp="vjzszietz2tj" />
              {contact.instagram}
            </a>
          </li>
        </ul>
        <p className="mt-10 text-xs leading-relaxed text-white/60" data-id="element-132" data-mp="zmw4yq9v80oi">
          © Hábil Online™ 2026 — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
        <p className="mt-4 text-base font-bold text-gold" data-id="element-133" data-mp="2fzbhcvktd7ne">
          “Tu colon sano. Tu vida libre. Empieza hoy.”
        </p>
      </div>
    </footer>;
}